import { Box, DashboardModule } from '@domain-group/suit-theme'

import type { CampaignModel } from '@models/types'

import EntitySelector from '@components/EntitySelector'

import Campaign from './Campaign'

interface QuoteDataSourceProps {
  callbacks: {
    setSelectedCampaignId: (campaignId: number) => void,
  },
  selectedCampaign: CampaignModel,
  selectedCampaignId: number,
}

const QuoteDataSource = (props: QuoteDataSourceProps) => {
  const {
    callbacks: {
      setSelectedCampaignId,
    },
    selectedCampaign,
    selectedCampaignId,
  } = props

  return (
    <DashboardModule title="Data Source">
      <Box flexDirection="column" padding="large">
        <EntitySelector
          callbacks={{
            // @ts-expect-error TS2345
            selectItem: campaign => setSelectedCampaignId(campaign?.id),
          }}
          entityKey="campaigns"
          label="Select Campaign"
          requestOptions={{
            include_campaign_image: true,
          }}
          selectedItemId={selectedCampaignId}
        />

        <Campaign campaign={selectedCampaign} />
      </Box>
    </DashboardModule>
  )
}

export default QuoteDataSource
